import { createContext } from "react";
import { BaseInitialStateFunction } from "../routes";

export type StaticContextType = {
  initialState?: Function;
  statusCode?: number;
  getInitialState?: BaseInitialStateFunction;
  set?: (props: StaticContextType) => void;
};

const StaticContext = createContext<StaticContextType>({});

export default StaticContext;
